import { SelectionItem } from '../../../../domain/selectionItem'
import { ProductFilterFormState } from './ProductFilterFormContext'
import { getProductsFilters } from './getProductsFilters'

export function getCategoriesFilters(
  products: SelectionItem[],
  urlPath: string | undefined,
  formState: ProductFilterFormState,
  isEcommerce: boolean | undefined,
): CategoriesFilters[] {
  const categoriesFilterAsObject: Record<number, CategoriesFilters> = {}

  const productsToFilter = getProductsFilters(products, formState, isEcommerce, 'categories')

  productsToFilter.forEach((element) => {
    // Do Nothing
    if (!element.categoriesOfProduct || (urlPath && urlPath.indexOf('categories') > -1)) {
      return
    }
    // Get id & label
    const { id, label } = element.categoriesOfProduct
    // If categorie exist
    if (categoriesFilterAsObject[id]) {
      // Increment categorie
      categoriesFilterAsObject[id].numberOfOccurences++
      return
    }
    // Add a new categorie
    categoriesFilterAsObject[id] = { id, label, numberOfOccurences: 1 }
  })

  // Tranform Object in Array
  const categoriesFilters = Object.keys(categoriesFilterAsObject).map((id) => categoriesFilterAsObject[id])

  return categoriesFilters
}
